export const environment = {
  testing: false,
  production: false,
  producao: true,
  nome: 'HOM',
  recaptchaSiteKey: '6Lc68FcrAAAAANRDzG0v1ib5KZnMIuEUoG-lqDsz',
  dataDog: {
    org: 'itau-hom',
    rumName: 'EM6-itau-assetfront-site-logado',
    rumType: 'browser',
    applicationId: 'f87a2f5d-e87b-4ee0-b0b6-67d5a4a2498d',
    proxyToken: 'EM6-itau-assetfront-site-logado-browser',
    clientToken: 'puba1fa8b4e97943c42a1b6c23cb7c529f2',
    version: '1.0.0',
    env: 'hom',
    applicationUrl: 'https://assetfront.hom.cloud.itau.com.br/',
    externalApplication: false,
  },
  configuracoes: {
    app_relatorio_contabil_tempo_atualizacao_central: 15000,
    app_relatorio_contabil_quantidade_tentativas_atualizacao_central: 3,
    app_extrato_num_registros_pagina: 10,
    app_extrato_mensal_num_registros_pagina: 10,
    app_xml_quantidade_maxima_dias: 90,
    app_xml_quantidade_maxima_meses: 24,
    app_xml_tempo_atualizacao_central: 15000,
    app_xml_quantidade_tentativas_atualizacao_central: 3,
    correlation_id: 'x-itau-correlationID',
  },

  charon: {
    isCryptographed: false,
    initSessionUrl: 'https://apicd.hom.cloud.itau.com.br/iske',
    entrypoint: 'https://apicd.hom.cloud.itau.com.br/charon/gwcqqyt9',
    entrypointNoCrypto:
      'https://caronte.cyberdefense.hom.aws.cloud.ihf/charon/asfrnt',
    uri: 'https://apicd.hom.cloud.itau.com.br/charon/',
    id: 'gwcqqyt9',
    idNoCrypto: 'asfrnt',
    action_logon: 'logon',
    action_logout: 'logout',
    action_reset: 'reset',
    action_requisicoes_op: 'reqOp',
    action_requisicoes_op_form_data: 'reqOpFormData',
    session_name: 'x-charon-session',
    date_name: 'Date',
    timeout: 9,
    chave_flowid: 'flowId',
    valor_flowid: '5abb0b74-7125-4df3-af03-496578007f63',
    chave_id_investidor: 'id_investidor',
    chave_id_operador: 'id_operador',
    ops: {
      op_buscar_fundo_fy: 'op_buscar_fundo_fy',
      op_buscar_fundos_exclusivos: 'op_buscar_fundos_exclusivos',
      op_delete_fundos_exclusivos: 'op_delete_fundos_exclusivos',
      op_documents_link_download_file: 'op_documents_link_download_file',
      op_movimentacao_sub_conta: 'op_subcontas',
      op_movimentacao_dados_complementares_conta:
        'op_movimentacao_dados_complementares_conta',
      op_movimentacao_operador_conta_detalhe: 'op_operador_conta_detalhe',
      op_movimentacao: 'op_movimentacoes',
      op_movimentacao_dados_fundo_investimento: 'op_fundos_investimentos',
      op_movimentacao_por_id: 'op_movimentacoes-por-id',
      op_movimentacao_fundos_posicao: 'op_movimentacao_fundos_posicao',
      op_relatorios_contabeis: 'op_relatorios_contabeis',
      op_relatorios_contabeis_id: 'op_relatorios_contabeis_id',
      op_tipos_relatorios_contabeis: 'op_tipos_relatorios_contabeis',
      op_relatorios_carteiras_relatorios: 'op_carteiras_relatorios_contabeis',
      op_relatorios_contabeis_pre_definidos:
        'op_relatorios_contabeis_predefinidos',
      op_relatorios_contabeis_pre_definidos_por_id:
        'op_relatorios_contabeis_pre_definidos_por_id',
      op_extratos_exportar: 'op_extratos_contas_consolidados',
      op_extratos_visualizar: 'op_extratos_contas',
      op_arquivo_binario: 'op_arquivo_binario',
      op_busca_empresa: 'op_empresas',
      op_busca_operadores: 'op_operadores',
      op_contas_clientes: 'op_contas-correntes-clientes',
      op_get_cotistas_contas_paas: 'op_get_cotistas_contas_paas',
      op_get_conta_liquidacao_paas: 'op_get_conta_liquidacao_paas',
      op_get_empresa_sigla: 'op_get_empresa_sigla',
      op_get_empresa_por_sigla: 'op_get_empresa_por_sigla',
      op_get_empresa_por_cnpj: 'op_get_empresa_por_cnpj',
      op_get_fundos: 'op_get_fundos',
      op_get_valorcota: 'op_get_valorcota',
      op_get_subcontas: 'op_get_subcontas',
      op_get_ordens_operacao: 'op_get_ordens_operacao',
      op_get_pacs: 'op_get_pacs',
      op_envia_operacoes_pac_paas: 'op_envia_operacoes_pac_paas',
      op_get_saldo_conta: 'op_get_saldo_conta',
      op_permissoes_contas: 'op_permissoes-contas',
      op_permissoes_contas_get: 'op_permissoes-contas-get',
      op_exclusao_contas_correntes_clientes:
        'op_exclusao-contas-correntes-clientes',
      op_list_taxas_fundos: 'op_list_taxas_fundos',
      op_operacoes_upload: 'op_operacoes_upload',
      op_envia_movimentacao_planilha: "op_envia_movimentacao_planilha",
      op_busca_movimentacao_planilha: "op_busca_movimentacao_planilha",
      op_busca_movimentacao_planilha_agrupamento: "op_busca_movimentacao_planilha_agrupamento",
      op_operacoes_download: 'op_operacoes_download',
      op_download_movimentacao_planilha: 'op_download_movimentacao_planilha',
      op_download_bucket_movimentacao_planilha: 'op_download_bucket_movimentacao_planilha',
      op_operacoes_detalhes: 'op_operacoes_detalhes',
      op_operacoes_logs: 'op_operacoes_logs',
      op_operacoes_historico: 'op_operacoes_historico',
      op_busca_carteiras_xml: 'op_carteiras_fundos',
      op_solicitacao_xml: 'op_solicitacao_download_xml',
      op_salvar_empresa: 'op_salvar_empresa',
      op_busca_solicitacao_xml: 'op_busca_solicitacao_xml',
      op_busca_inconsistencia_itens_xml: 'op_busca_inconsistencia_itens_xml',
      op_xml_atualizar_download: 'op_xml_atualizar_download',
      op_busca_carteiras: 'op_carteiras_diarias',
      op_gravar_log: 'op_log',
      op_log_frontend_api: 'op_log_frontend_api',
      op_log_frontend_script: 'op_log_frontend_script',
      op_documents_list_files: 'op_documents_list_files',
      op_documents_download_file: 'op_documents_download_file',
      op_documents_upload_file: 'op_documents_upload_file',
      op_documents_delete_file: 'op_documents_delete_file',
      op_documents_create_doc_type: 'op_documents_create_doc_type',
      op_documents_list_doc_type: 'op_documents_list_doc_type',
      op_documents_delete_doc_type: 'op_documents_delete_doc_type',
      op_list_empresas: 'op_list_empresas',
      op_mov_etf_get_all_etfs: 'op_mov_etf_get_all_etfs',
      op_mov_etf_post_list_tickets: 'op_mov_etf_post_list_tickets',
      op_mov_etf_get_all_status: 'op_mov_etf_get_all_status',
      op_mov_etf_delete_ticket: 'op_mov_etf_delete_ticket',
      op_mov_etf_post_ticket: 'op_mov_etf_post_ticket',
      op_mov_etf_update_ticket: 'op_mov_etf_update_ticket',
      op_invest_etf_get: 'op_invest_etf_get',
      op_invest_etf_post: 'op_invest_etf_post',
      op_documents_update_file: 'op_documents_update_file',
      op_documents_filter_files_operator: 'op_documents_filter_files_operator',
      op_invest_custodiante_get: 'op_invest_custodiante_get',
      op_invest_etf_patch: 'op_invest_etf_patch',
      op_invest_etf_delete: 'op_invest_etf_delete',
      op_operadores_vinculos: 'op_operadores_vinculos',
      op_add_fundos_exclusivos: 'op_add_fundos_exclusivos',
      op_validar_elegibilidade_investidor_aplicacao: 'op_validar_elegibilidade_investidor_aplicacao',
      op_assinar_termo: 'op_assinar_termo',
      op_confirmar_assinatura_termos_planilha: 'op_confirmar_assinatura_termos_planilha',
      op_agente_perguntar: 'op_agente_perguntar',
    },
  },
};
